import type { IconProps } from './IconProps';

export const DotsIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <g>
      <path
        d="M3.5 8C3.5 7.17157 2.82843 6.5 2 6.5C1.17157 6.5 0.5 7.17157 0.5 8C0.5 8.82843 1.17157 9.5 2 9.5C2.82843 9.5 3.5 8.82843 3.5 8Z"
        fill="currentColor"
      />
      <path
        d="M9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5C8.82843 9.5 9.5 8.82843 9.5 8Z"
        fill="currentColor"
      />
      <path
        d="M15.5 8C15.5 7.17157 14.8284 6.5 14 6.5C13.1716 6.5 12.5 7.17157 12.5 8C12.5 8.82843 13.1716 9.5 14 9.5C14.8284 9.5 15.5 8.82843 15.5 8Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
